var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-app-container"},[_c('div',{staticClass:"sr-app-container__sidebar",class:{ collapsed: _vm.isClosed }},[_vm._t("sidebar")],2),_c('div',{staticClass:"sr-app-container__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }